import { Fragment } from 'react';

type TwitterCardsProps = {
  card?: string;
  title?: string;
  description?: string;
  image?: string;
  site?: string;
};

function TwitterCards({
  title,
  description,
  image,
  site,
  card,
}: TwitterCardsProps) {
  return (
    <Fragment>
      {card && <meta name="twitter:card" content={card} />}
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {site && <meta name="twitter:site" content={site} />}
    </Fragment>
  );
}

export default TwitterCards;
